import React from "react"
import Layout from "../../components/Layout"
import Header from "../../components/Header"
import CaseStudy, {
  CASE_STUDY_TYPES,
} from "../../components/case-study/CaseStudy"
import ThumbnailImage from "../../images/thumbnails/case_study_home.png"
import Hero from "../../components/case-study/home/Hero"
import MagicWithUs from "../../components/inner-page/MagicWithUs"
import CasestudyLists from "../../components/case-study/home/CasestudyLists"
import MoreBrands from "../../components/case-study/home/MoreBrands"
import MoreCaseStudy from "../../components/case-study/MoreCaseStudy"
import PremagicNewsSection from "../../components/PremagicNews"

export function Index() {
  return (
    <Layout
      title="Premagic Case Studies - Event Success Stories"
      description="Explore how leading brands use Premagic AI to transform events. Real results from 100+ successful implementations worldwide."
      metaImage={ThumbnailImage}
      keywords={[
        "Premagic case studies",
        "event success stories",
        "AI event platform results",
        "event technology ROI",
        "corporate event case studies",
        "conference success stories",
        "event marketing results",
        "attendee engagement case studies",
      ]}
      breadcrumbs={[
        { name: "Home", url: "/" },
        { name: "Case Studies", url: "/case-study/" },
      ]}
    >
      <Header />
      <Hero />
      <CasestudyLists />
      <MoreBrands />
      <MoreCaseStudy itemsToShow={6} currentPage="home" />
      <PremagicNewsSection />
      <MagicWithUs />
    </Layout>
  )
}

export default Index
